export default "../src/img/placeholder.jpg";